import React from "react";
import Icon from "sulu-admin-bundle/components/Icon/Icon.js";
import QuarterButton from "../QuarterButton";
import overrides from "../../../../css/customization.scss";
import style from "../../../../css/components/buttons.scss";
import Comment from "../../../../svgs/Comment";
import { formatMatches } from "../../../utils/format-matches";

import styles from "./timer.module.scss";

const TimerHeader = ({
    timersPerQuarter,
    quarterSelected,
    setQuarterSelected,
    matchData,
    setComponentToInsertInModal,
    setIsModalOpen,
    EVENT_TYPES,
    setEventDetailsToAdd,
    TOTAL_TIME_PLAYED,
}) => {
    const [quarters] = formatMatches(matchData.formatObject);
    return (
        <div className={styles["timer-header"]}>
            <div className={styles["timer-header__title"]}>
                <Icon name="su-clock" />
                <p className={overrides.fontRoboto}>Zeit</p>
            </div>
            <div
                style={{
                    display: "flex",
                    width: "100%",
                }}
            >
                {Object.entries(timersPerQuarter)?.map(
                    ([quarter, quarterDetails], index) => {
                        const periodNumber = index + 1;
                        if (index < quarters) {
                            return (
                                <QuarterButton
                                    key={index}
                                    periodNumber={periodNumber}
                                    quarter={quarter}
                                    quarterSelected={quarterSelected}
                                    setQuarterSelected={setQuarterSelected}
                                    quarterDetails={quarterDetails}
                                    matchData={matchData}
                                />
                            );
                        }
                        if (
                            Object.keys(timersPerQuarter).length ===
                            periodNumber
                        ) {
                            return (
                                <QuarterButton
                                    key={index}
                                    periodNumber={periodNumber}
                                    quarter={quarter}
                                    quarterSelected={quarterSelected}
                                    setQuarterSelected={setQuarterSelected}
                                    quarterDetails={quarterDetails}
                                    matchData={matchData}
                                />
                            );
                        }
                    }
                )}
                <button
                    className={`${style.quarterBtn} ${style.commentBtn}`}
                    onClick={() => {
                        const event = EVENT_TYPES.find(
                            (ev) => ev.name === "COMMENT"
                        );
                        setComponentToInsertInModal(event.addComponentToOpen);
                        setEventDetailsToAdd({
                            type: event,
                            timestamp: TOTAL_TIME_PLAYED,
                            quarterSelected,
                            liveEvent: true,
                            postType: 17,
                        });
                        setIsModalOpen(true);
                    }}
                >
                    <Comment fill={"#fff"} />
                    Kommentar
                </button>
            </div>
        </div>
    );
};
export default TimerHeader;
